<template lang="pug">
  .days-count-toggler(v-click-outside="() => { toggled = false }")
    span(v-html="`${$t('base.сonsumption_for')} ${ $t(selected.label) } ${$t('base.kg')}`")
    v-toggler.toggler(v-model="toggled")
    .days-count-toggler__options(
      v-if="toggled")
      v-card(
        elevated
        overflow-hidden)
        .options__item(
          v-for="(item, index) in items"
          @click="onItemClick(index)")
          | {{ item.label | translate }}
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

export default {
  name: 'DaysCountToggler',

  mixins: [adaptationMixin],

  props: {
    value: {
      type: Number,
      default: 1
    }
  },

  data: () => ({
    items: [
      { label: 'base.1_day', value: 1 },
      { label: 'base.7_days', value: 7 },
      { label: 'base.14_days', value: 14 },
      { label: 'base.30_days', value: 30 }
    ],
    toggled: false
  }),

  computed: {
    selected () {
      return this.items.find(item => item.value === this.value)
    }
  },

  methods: {
    onItemClick (index) {
      this.toggled = false
      this.$emit('input', this.items[index].value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_mixins.scss';
  @import '@/sass/abstracts/_variables.scss';

  .days-count-toggler {
    position: relative;
    width: 140px;
    span {
      padding-right: 10px;
    }

    @include mobile {
      width: auto;
    }

    .toggler {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);

      @include mobile {
        right: -3rem;
      }
    }

    .days-count-toggler__options {
      width: 100%;
      position: absolute;
      top: 40px;
      z-index: 99;

      @include mobile {
        top: 2.6rem;
        left: 3rem;
      }

      .options__item {
        cursor: pointer;
        user-select: none;
        color: $color-black;
        padding: 8px 16px;

        &:hover {
          background-color: $table-row-bg;
        }
      }
    }
  }
</style>
